/* src/components/pages/BullMQDashboard.jsx - Modificado el 25-02-2026 */
/* ------------------------ Dashboard BullMQ ------------------------- */

import React, { useEffect, useState, useCallback } from 'react';
import { Box, Stack, Card, CardContent, Typography } from "@mui/material";

import api from "../../services/api.js";

import { useFeedback } from '../../context/FeedbackContext'; // Mensajes breves

import NoData from "./NoData.jsx";

const BullMQDashboard = ({ modo }) => {

  const [colas, setColas] = useState([]);

  const { showFeedback } = useFeedback(); // Mensajes breves no bloqueantes

  // =============== Obtener datos BullMQ ===============
  const fetchBullStats = useCallback(async () => {

    try {
      const response = await api.get("/bull/getqueues", {
      });

      if (response.data.ok) {

        const formateado = response.data.queues.map(q => ({
          name: q.name,
          active: q.count.active,
          completed: q.count.completed,
          delayed: q.count.delayed,
          failed: q.count.failed,
          waiting: q.count.waiting,
          prioritized: q.count.prioritized || 0
        }));

        setColas(formateado);

      } else {
        setColas([]);
      }

    } catch (err) {
      console.error("❌ Error BullMQ:", err);

      showFeedback({
        message: "No fue posible obtener el estado de las colas",
        severity: "error",
      });
    }

  },[showFeedback]);

  useEffect(() => {
    fetchBullStats();
  }, [fetchBullStats]);

  // =============== Render ===============
  const renderCard = (titulo, valor) => (
    <Card
      sx={{
        width: 220,                 // 🔥 ancho consistente
        height: 110,                // 🔥 altura fija uniforme
        backgroundColor: (theme) => theme.custom.ui.surfaceBg,
        borderRadius: 2,
        boxShadow: (theme) => theme.custom.ui.surfaceShadow,
        display: "flex",
      }}
    >
      <CardContent
        sx={{
          display: "flex",
          flexDirection: "column",
          justifyContent: "center",
          alignItems: "center",     // 🔥 centra horizontal
          width: "100%",
          textAlign: "center",
          p: 2,
        }}
      >
        <Typography
          variant="body2"           // 🔥 más compacto que h6
          sx={{
            fontWeight: 600,
            opacity: 0.8,
            mb: 0.5,
          }}
        >
          {titulo}
        </Typography>

        <Typography
          variant="h5"              // 🔥 antes era h4 (muy grande)
          sx={{
            fontWeight: 700,
            color: "primary.main",
            lineHeight: 1.1,
          }}
        >
          {valor}
        </Typography>
      </CardContent>
    </Card>
  );

  return (
    <Box sx={{ width: '100%', pt: 0, overflow: 'visible' }}>
      <Stack
        direction="row"
        flexWrap="wrap"
        justifyContent="center"
        alignItems="flex-start"
        gap={1}   // espacio horizontal y vertical
        sx={{ mt: 1, mb: 1 }}
      >
        {colas.length > 0 ? (
          colas.map((cola, index) => (
            <Box
              key={index}
              sx={{
                display: "flex",
                flexWrap: "wrap",
                justifyContent: "center",
                gap: 2,
                width: "100%",
                mt: 2,
              }}
            >
              <Typography variant="h5" sx={{ width: "100%", textAlign: "center", mb: 1 }}>
                {cola.name}
              </Typography>

              {renderCard("Pendientes", cola.waiting)}
              {renderCard("Activos", cola.active)}
              {renderCard("Completados", cola.completed)}
              {renderCard("Fallados", cola.failed)}
              {renderCard("Retenidos", cola.delayed)}
              {renderCard("Prioritarios", cola.prioritized || 0)}
            </Box>
          ))
        ) : (
          <NoData mensaje="No hay información de BullMQ" />
        )}
      </Stack>
    </Box>
  );
};

export default BullMQDashboard;
